import axios from 'axios'
import Cookies from 'universal-cookie'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'
import moment from 'moment'
import exactMath from 'exact-math'
import numeral from 'numeral'


import { API_URL, API_IATACODES } from '../actions/index'
import store from '../utils/store'
import { isNumber } from 'util';

const cookies = new Cookies()

export function createAxiosInstance(config) {
    const token = cookies.get('token')
    if (!token) return null
    let minConfig = {
        baseURL: API_URL,
        headers: { 'Authorization': `Bearer ${token}` }
    }
    if (config) {
        minConfig = { ...minConfig, ...config }
    }

    return axios.create(minConfig)
}



export function createAxiosAirports() {
    let minConfig = {
        baseURL: API_IATACODES,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
        }
    }
    return axios.create(minConfig)
}


// export function createAxiosAirports() {
//     return axios.create()
// }

export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export function addTitleIfOverflow(element) {
    if (element.offsetWidth <= element.scrollWidth && !element.hasAttribute('title')) {
        element.setAttribute('title', element.innerHTML)
    }
}

export function isPrimitive(test) {
    return (test !== Object(test))
}

export function isFunction(fn) {
    return fn && {}.toString.call(fn) === '[object Function]';
}

export const uniqueArray = (arr) => [...new Set(arr)]

export function transformParameterData(parametro) {
    const columnas = []
    const table = parametro.parametro_cols.reduce((a, b) => {
        if (columnas.filter(c => c.nombre === b.nombre).length === 0) {
            columnas.push({
                id: b.id,
                posicion: Number(b.Position),
                caption: b.nombre.replace('_', ' '),
                value: b.nombre,
                type: 'string',
                format: '',
                parametro_id: parametro.id,
                parametro_col_id: b.id
            })
        }
        b.parametro_rows.forEach(x => {
            if (!a[x.registro]) a[x.registro] = {
                id: null,
                valor: null,
                updated: false,
                guid: guid(),
                parametro_id: parametro.id,
                parametro_col_id: b.parametro_col_id
            }
            a[x.registro].registro =  x.registro
            a[x.registro][b.nombre] = { id: x.id, valor: x.valor, updated: false, guid: guid(), parametro_id: parametro.id, parametro_col_id: b.id }
        })
        return a
    }, {})

    const data = []
    for (let key in table) {
        if (table.hasOwnProperty(key)) {
            const obj = columnas.reduce((a, b) => {
                a[b.value] = null
                a.selected = false
                a.deleted = false
                return a
            }, {})
            data.push({...obj, ...table[key]})
        }
    }

    return { parametro, columnas, data }
}

export const operators = [
    { id: 1, value: '===', caption: 'Igual a', comparisons: ['string', 'number', 'datetime'] },
    { id: 2, value: '!==', caption: 'Diferente de', comparisons: ['string', 'number', 'datetime'] },
    { id: 3, value: '>', caption: 'Mayor a', comparisons: ['number', 'datetime'] },
    { id: 4, value: '>=', caption: 'Mayor o igual a', comparisons: ['number', 'datetime'] },
    { id: 5, value: '<', caption: 'Menor a', comparisons: ['number', 'datetime'] },
    { id: 6, value: '<=', caption: 'Menor o igual a', comparisons: ['number', 'datetime'] },
    { id: 7, value: 'like', caption: 'Contiene', comparisons: ['string', 'datetime'] },
]

export const acceptedFiles = [
    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', icon: 'xlsx.png' },
    { type: 'text/csv', icon: 'xlsx.png' },
    { type: 'application/vnd.ms-excel', icon: 'xlsx.png' },
    { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', icon: 'pptx.png' },
    { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', icon: 'doc.png' },
    { type: 'application/pdf', icon: 'pdf.png' },
    { type: 'application/x-zip-compressed', icon: 'zip.png' },
    { type: 'image/*', icon: 'jpg.png' },
]


// export const acceptedFilesCSV = [
//     { type: 'text/csv', icon: 'xlsx.png' }
// ]


// 8M = 8388608 Bytes
export const uploadMaxSize = {
    value: 8388608,
    unidad: '8M'
}



export const queryString = (search, param) => {
    return search.split('?')[1].split(`${param}=`)[1].split('&')[0];
}

export const enums = {
    solicitudes: {
        tipos: {
            1: { caption: 'Servicios', url: 'servicios', type: 'ACTUALIZAR_SOLICITUD_SERVICIO', responsable: null },
            2: { caption: 'Contrato anual', url: 'contratos-anuales' , type: 'ACTUALIZAR_SOLICITUD_CONTRATOANUAL', responsable: null},
            3: { caption: 'Servicio oficina técnica', url: 'servicios-oficina-tecnica', type: 'ACTUALIZAR_SOLICITUD_SERVICIO_OT', responsable: null},
            4: { caption: 'Tiquetes aéreos', url: 'tiquetes-aereos', type: 'ACTUALIZAR_SOLICITUD_TIQUETESAEREOS', responsable: null},
            5: { caption: 'OTROSI', url: 'otrosi', responsable: null},
            6: { caption: 'Bienes e investigación - Laboratorio', url: 'bienes-investigacion', type: 'ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION', responsable: null },
            7: { caption: 'Bienes e investigación - Materiales', url: 'bienes-investigacion', type: 'ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION', responsable: null },
            8: { caption: 'Hoteles', url: 'hoteles', responsable: null},
        },
        estados: {
            0: 'Cancelada',
            1: 'Creada',
            2: 'En cotización',
            3: 'En aprobación',
            4: 'Aprobada',
            5: 'En aprobación proveedor',
            6: 'En proceso',
            7: 'Cerrada',
            8: 'Validado',
            9: 'Cerrado NV'
        }
    },
    aprobaciones: {
        estados: {
            0: 'Rechazada',
            1: 'Pendiente',
            2: 'Aprobada',
            3: 'En revision',
            4: 'Omitido'
        }
    },
    documentos: {
        tipos: {},
        estados: {
            0: 'Cancelado',
            1: 'Creado',
            2: 'En aprobacion proveedor',
            3: 'Aprobado proveedor',
            4: 'En ejecución',
            5: 'En revisión entrega',   //Ajustes documentos
            6: 'En ajustes entrega',    //Ajustes proveedor
            7: 'Recibido',
            8: 'En ajustes SOMA',
            9: 'Recibido SOMA',
            10: 'A espera de factura',
            11: 'Cerrada',
            12: 'Vigente',
            13: 'En espera',
            14: 'Vigente sin renovación'
        }
    },
    cotizaciones: {
        estados: {
            0: 'Cancelado',
            1: 'Creado',
            2: 'En aprobacion proveedor',
            3: 'Aprobado proveedor',
            4: 'Aprobada',
            5: 'Solicitar cotizacion'
        }
    },
    etapas: {
        "1-1": "Generar Orden/Contrato",
        "1-2": "Actualizar Orden/Contrato",
        "1-3": "Generar Orden/Contrato con ajustes",
        "1-4": "Registrar adicionales para ajustar factura",
        "1-5": "Generar OTROSÍ",
        "1-6": "Actualizar OTROSÍ",
        "2-1": "Solicitar Cotizaciones",
        "2-2": "Analizar Cotizaciones",
        "2-3": "Generar Orden/Contrato",
        "2-4": "Actualizar Orden/Contrato",
        "2-5": "Generar Orden/Contrato con ajustes",
        "2-6": "Generar OTROSÍ",
        "2-7": "Actualizar OTROSÍ",
        "3-1": "Solicitar Cotizaciones",
        "3-2": "Analizar Cotizaciones",
        "3-3": "Registrar Compra",
        "3-4": "Generar Orden/Contrato",
        "3-5": "Actualizar Orden/Contrato",
        "3-6": "Generar Orden/Contrato con ajustes",
        "3-7": "Generar OTROSÍ",
        "3-8": "Actualizar OTROSÍ",
        "4-1": "Registrar Cotizaciones",
        "4-2": "Registrar Compra Tiquetes Aéreos",
        "4-3": "Registrar Compra Asistencia al Viajero",
        "4-4": "Registrar cumplimiento del tiquete",
        "5-1": "Registrar Cotizaciones",
        "5-2": "Registrar Pago del Hotel",
        "5-3": "Registrar cumplimiento de la estadía",
        "6-1": "Generar Contrato Anual",
        "6-2": "Rechazar Contrato Anual",
        "6-3": "Actualizar Contrato Anual",
        "6-4": "Adjuntar Contrato con firmas",
        "6-5": "Registrar Renovación Contrato Anual",
        "6-6": "Rechazar Renovación Contrato Anual",
    },
    etapasFilter: {
        "Actualizar Contrato Anual": "Actualizar Contrato Anual",
        "Actualizar Orden/Contrato": "Actualizar Orden/Contrato",
        "Actualizar OTROSÍ": "Actualizar OTROSÍ",
        "Adjuntar Contrato con firmas": "Adjuntar Contrato con firmas",
        "Analizar Cotizaciones": "Analizar Cotizaciones",
        "Generar Contrato Anual": "Generar Contrato Anual",
        "Generar Orden/Contrato con ajustes": "Generar Orden/Contrato con ajustes",
        "Generar Orden/Contrato": "Generar Orden/Contrato",
        "Generar OTROSÍ": "Generar OTROSÍ",
        "Rechazar Contrato Anual": "Rechazar Contrato Anual",
        "Rechazar Renovación Contrato Anual": "Rechazar Renovación Contrato Anual",
        "Registrar adicionales para ajustar factura": "Registrar adicionales para ajustar factura",
        "Registrar Compra Asistencia al Viajero": "Registrar Compra Asistencia al Viajero",
        "Registrar Compra Tiquetes Aéreos": "Registrar Compra Tiquetes Aéreos",
        "Registrar Compra": "Registrar Compra",
        "Registrar Cotizaciones": "Registrar Cotizaciones",
        "Registrar cumplimiento de la estadía": "Registrar cumplimiento de la estadía",
        "Registrar cumplimiento del tiquete": "Registrar cumplimiento del tiquete",
        "Registrar Pago del Hotel": "Registrar Pago del Hotel",
        "Registrar Renovación Contrato Anual": "Registrar Renovación Contrato Anual",
        "Solicitar Cotizaciones": "Solicitar Cotizaciones",
    },
    tipos_identificacion: {
        1: 'Cédula de ciudadania',
        2: 'Cédula de extranjería',
        3: 'Pasaporte',
        4: 'Tarjeta de identidad'
    }
}


export const extractKeyValue = (object, pathvalue=null, pathtext=null) => {

    object = Immutable.fromJS(object)
    const keyvalue = []

    if (object instanceof Immutable.Map) {
        object.mapKeys((value, item) => {
            const text = pathvalue ? item.getIn(pathvalue.split('.')) : item
            keyvalue.push({value, text})
        })
    }

    if (object instanceof Immutable.List) {
        if (pathvalue == null) return
        if (pathtext == null) return
        object.map(x => {
            const value = x.getIn(pathvalue.split('.'))
            const text = x.getIn(pathtext.split('.'))
            keyvalue.push({value, text})
        })
    }

    return keyvalue
}

export const parametro = () => {
    return {
        id: null,
        guid: guid(),
        nombre: '',
        descripcion: '',
        categoria: '',
        selected: false,
        visible: true,
        parametro_cols: [parametroConfig()],
    }
}

export const parametroConfig = () => {
    return {
        id: null,
        guid: guid(),
        posicion: 1,
        nombre: '',
        descripcion: '',
        selected: false,
    }
}

export const usuario = (permisos, grupos) => {
    return {
        username: '',
        email: '',
        es_supeusuario: false,
        ldap: false,
        esta_activo: true,
        nombres: '',
        apellidos: '',
        extension: '',
        permisos,
        grupos,
        reporta_a: {}
    }
}

export const grupo = () => {
    return {
        guid: guid(),
        nombre: '',
        descripcion: ''
    }
}

export const solicitudservicioitem = () => {
    return {
        id: null,
        selected: false,
        guid: guid(),
        descripcion: '',
        cantidad: 0,
        cencos: [],
        cotizado: 0,
        cotizado_iva: 0,
        iva: 0,
    }
}

export const grupoItem = () => {
    return {
        id: null,
        guid: guid(),
        items: [],
        proveedores: [],
        compra_directa: false
    }
}

export const solicitudbiitem = () => {
    return {
        id: null,
        selected: false,
        guid: guid(),
        descripcion: '',
        cantidad_requerida: 0,
        descripcion_erp: '',
        cantidad_solicitada: 0,
    }
}

export const compraDirectaItem = () => {
    return {
        id: null,
        guid: guid(),
		razon_social: '',
		nit: '',
		no_factura: '',
        fecha_compra: moment(),
        medio_pago: '',
        valor_compra: ''
    }
}

export const solicitudservicioitemcenco = (actual = 0) => {
    return {
        id: null,
        guid: guid(),
        cenco: null,
        porcentaje: 100 - actual
    }
}


export const solicitudcenco = (actual = 0) => {
    return {
        id: null,
        guid: guid(),
        cenco: null,
        responsable: null,
        porcentaje: 100 - actual
    }
}

export const detalleparametro = (columnas, registro) => {
    const output = {
        registro: registro,
        selected: false
    }
    columnas.forEach(x => {
        output[x.get('value')] = { guid: guid(), id: null, updated: true, valor: '', parametro_id: x.get('parametro_id'), parametro_col_id: x.get('parametro_col_id') }
    })
    return output
}

export const solicitudserviciofile = () => {
    return {
        id: null,
        updated: true,
        guid: guid(),
        nombre: '',
        observaciones: '',
        file: null,
        icono: null,
        selected: false,
        editable: 1
    }
}


export const adjunto = () => {
    return {
        id: null,
        updated: true,
        guid: guid(),
        nombre: '',
        observaciones: '',
        file: null,
        icono: null,
        selected: false,
        editable: 1,
        documento_id: null,
        solicitud_id: null,
        entities: []
    }
}



export const tiquete = () => {
    return {
        id: null,
        guid: guid(),
        aerolinea: '',
        fecha: null,
        origen: '',
        destino: '',
        sale: null,
        llega: null,
        valor_aprobado: 0,
        valor_pagado: 0,
        viaje_id: null
    }
}




export const cotizacion = () => {

    return {
        id: null,
        updated: true,
        guid: guid(),
        cotizado: 0,
        fecha_entrega: moment().format('YYYY-MM-DD'),
        forma_pago: '',
        servicio: null,
        proveedor_id: null,
        proveedore: null,
        descripcion: '',
        adjunto_id: null,
        selected: false,
        adjunto: adjunto(),
        estado: 1,
        moneda: 'COP'
    }
}


export const proveedor_servicio = () => {

    return {
        id: null,
        guid: guid(),
        fecha_cotizo: null,
        servicio: null,
        proveedore: null,
        adjunto: adjunto(),
        selected: false
    }
}

export const modified = (id, entity, value, action) => {
    return {
        id,
        entity,
        value,
        action,
    }
}


export const plantilla = () => {
    return {
        id: null,
        guid: guid(),
        nombre: '',
        text: '',
        tipo: 0
    }
}



export const garantia = () => {
    return {
        id: null,
        selected: false,
        guid: guid(),
        nombre: '',
        texto: ''
    }
}

export const documento = (documento_id, solicitud_id, proveedor_id) => {
    return {
        id: null,
        guid: guid(),
        documento_id: null,
        solicitud_id: null,
        proveedor_id: null,
        plantilla_id: null,
        fecha_inicio: moment().format('YYYY-MM-DD'),
        fecha_entrega: moment().format('YYYY-MM-DD'),
        garantias: [],
        dias_pagados_saldo: 0
    }
}

export const factura = (documento_id) => {
    return {
        id: null,
        guid: guid(),
        documento_id,
        numero_factura: '',
        fecha_factura: null,
        fecha_radicacion: null,
        valor_sin_iva: null,
        valor_con_iva: null,
        selected: false,
        visible: true,
        file: null,
        amortizacion: null,
        porcentaje_amortizacion: null,
        valor_a_pagar: null
    }
}

export const adicion = (documento_id) => {
    return {
        id: null,
        guid: guid(),
        documento_id,
        descripcion: '',
        cantidad: 1,
        valor: 0,
        iva: 0,
        valor_con_iva: 0,
        valor_unidad: 0,
        fecha_entrega: null,
        cencos: []
    }
}

export const verificacionSST = (documento_id) => {
    return {
        id: null,
        guid: guid(),
        documento_id,
        observaciones: '',
        file: null
    }
}


export function trayecto() {
    return {
        id: null,
        guid: guid(),
        selected: false,
        origen: '',
        aeropuerto_origen: '',
        fecha_ida: null,
        destino: '',
        aeropuerto_destino: '',
        fecha_regreso: null
    }
}


export function alojamiento() {
    return {
        id: null,
        guid: guid(),
        selected: false,
        ciudad: '',
        fecha_ingreso: null,
        fecha_salida: null,
        monto_consumo: 0,
        consumo_habitacion : 0
    }
}


export function asistencia() {
    return {
        id: null,
        guid: guid(),
        pais_destino: '',
        fecha_salida: null,
        fecha_regreso: null,
        avisar_a: '',
        direccion: '',
        ciudad: '',
        celular: '',
        telefono: '',
        proveedor: '',
        numero_voucher: '',
        valor: 0,
        fecha_compra: null
    }
}

export function pasajero() {
    return {
        id: null,
        guid: guid(),
        tipo_pasajero: 1,
        nombres: null,
        apellidos: null,
        cedula: null,
        correo: null,
        fecha_nacimiento: null,
        celular: null,
        nacionalidad: null,
        pasaporte: null,
        pais_expedicion: null,
        fecha_caducidad_pasaporte: "",
        pasaporte_adjunto: null,
        asistencia: asistencia(),
        tipo_documento: 1
    }
}


export function huesped() {
    return {
        id: null,
        guid: guid(),
        tipo_huesped: 1,
        nombres: null,
        apellidos: null,
        tipo_documento: 1,
        numero_documento: '',
        celular: null
    }
}

export function proveedor() {
    return {
        id: null,
        guid: guid(),
        nombre: null,
        identificacion: null,
        representante: null,
        cc_representante: null,
        contacto: null,
        correo: null,
        telefono: null,
        cargo: null,
        direccion: null
    }
}

export function foro(usuario, comentario) {
    return {
        guid: guid(),
        id: null,
        comentario,
        solicitud_id: null,
        usuario_id: usuario.get('id'),
        usuario,
        updated_at: moment().format('YYYY-MM-DD HH:mm:ss')
    }
}

export function esEntero(x){
	var y = parseInt(x);
	if (isNaN(y))
		return false;
	return x == y && x.toString() == y.toString();
}

export function getModificaciones(newObj, OldObj, entity, outputTransformations) {
    const ops = diff(OldObj, newObj)
    const modificaciones = []

    ops.forEach(x => {

        let path = x.get('path').split('/')
        path.shift()
        let value = x.get('value')

        if (value === undefined && x.get('op') === 'remove') {
            value = path[path.length - 1]
        }

        if (!isPrimitive(value)) {
            if (Immutable.Map.isMap(value) || Immutable.List.isList(value)) {
                value = value.toJS()
            }
        }
        // Modificado por David
        const attr = path[0]
        const id = esEntero(attr) ? newObj.getIn([attr, 'id'])  : newObj.get('id')
        //----

        //let modificacion = { id: newObj.get('id'), entity: entity, attribute: path, value: value, action: x.get('op') }
        let modificacion = {
            id,
            entity: entity,
            attribute: path,
            value: value,
            action: x.get('op') ,
            relation : (path[1] !== undefined && path[1] !== null) ? path[1] : "",
            column:(path[3] !== undefined && path[3] !== null) ? path[3] : "" ,
            idRelation : newObj.getIn([attr, (path[1] !== undefined && path[1] !== null) ? path[1] : "" , (path[2] !== undefined && path[2] !== null) ? path[2] : ""  , 'id'])
        }

        // if (isFunction(outputTransformations)) {
        //     outputTransformations(x, modificacion)
        // }

        if (isFunction(outputTransformations)) {
            outputTransformations(x, modificacion, newObj)
        }

        if (modificacion !== null && modificacion.entity !== null) modificaciones.push(modificacion)
    })


    return modificaciones
}

//Original
// export function getModificaciones(newObj, OldObj, entity, outputTransformations) {
//     const ops = diff(OldObj, newObj)
//     const modificaciones = []
//     ops.forEach(x => {
//         let path = x.get('path').split('/')
//         path.shift()
//         let value = x.get('value')
//         if (value === undefined && x.get('op') === 'remove') {
//             value = path[path.length - 1]
//         }
//         if (!isPrimitive(value)) {
//             if (Immutable.Map.isMap(value) || Immutable.List.isList(value)) {
//                 value = value.toJS()
//             }
//         }
//         let modificacion = { id: newObj.get('id'), entity: entity, attribute: path, value: value, action: x.get('op') }
//         if (isFunction(outputTransformations)) {
//             outputTransformations(x, modificacion)
//         }
//         if (modificacion !== null && modificacion.entity !== null) modificaciones.push(modificacion)
//     })

//     return modificaciones
// }




export function indexBy(iterable, searchKey) {
    return iterable.reduce(
        (lookup, item) => lookup.set(item.get(searchKey), item),
        Immutable.Map()
    )
}

export function groupModificacionesBy(modificaciones, entity, action) {
    let newModificaciones = []
    const newValues = {}
    let id = null
    modificaciones.forEach((a, b) => {
        if (a.entity !== entity) {
            newModificaciones = newModificaciones.concat({...a})
        } else {
            id = a.id
            if (a.action !== 'hidden') {
                newValues[a.attribute] = a.value
            }
        }
    })
    newModificaciones = newModificaciones.concat({id, entity, action, value: newValues})

    return newModificaciones
}

export function isAllowedToViewComponent(type, obj, check) {
    const user = store.getState().common.get('user')
    const parametros = store.getState().common.get('parametros')
    let solicitud = null
    if (type === 'documento') {
        solicitud = obj.get('solicitude')
        if (obj.get('estado') === 0 || obj.get('estado') === 11 || obj.get('estado') === 12) return false
        if (solicitud.getIn(['solicitud', 'estado']) === 0 || solicitud.getIn(['solicitud', 'estado']) === 7) return false
    } else if (type === 'solicitud') {
        if (obj.getIn(['solicitud', 'estado']) === 0 || obj.getIn(['solicitud', 'estado']) === 7) return false
    } else if (type === 'aprobacion') {
        if (obj.get('estado') !== 1) return false
        if ((user.get('es_superusuario') === 1)) return true
        if (obj.get('estado') === 1 && obj.get('aprobador_id') !== user.get('id')) return false
    }
    else if (type === 'aprobaciones') {

        if ((user.get('es_superusuario') != 1)) {
            return user.get('id') == obj.get('id')
        } else {
            return true
        }
     } else if (type === 'aprobador') {
        if ((user.get('es_superusuario') != 1)) {
            return obj.filter(aprobador => aprobador.get('id') == user.get('id')).count() > 0
        } else {
            return true
        }
    } else if (type=='administrador') {
        if (user.get('es_superusuario') === 1) return true
        if ((obj) && (user.get('id') == obj.get('id'))) return true
        return false;
    } else if (type == 'responsables_recibo') {
        if (user.get('es_superusuario') === 1) return true
        solicitud = obj.get('solicitude')
        return (solicitud.get('responsables_recibo').filter(x => x.get('usuario_id') == user.get('id')).count() > 0 || solicitud.getIn(['responsable_compras', 'id']) === user.get('id')) && (user.get('id') == check)
    } else if (type == 'responsable_almacen') { //Ingresa la factura

        if (user.get('es_superusuario') === 1) return true

        if (obj.getIn(['solicitude', 'responsable_compras', 'id']) === user.get('id')) return true

        const almacen = parametros.get('ALMACEN').filter(x => x.get('ALMACEN') == obj.get('almacen')).first()
        if (almacen) {
            return user.get('username') === almacen.get('USUARIO')
        }
        solicitud = obj.get('solicitude')
        return (solicitud.get('responsables_ingreso').filter(x => x.get('usuario_id') == user.get('id')).count() > 0 || solicitud.getIn(['responsable_compras', 'id']) === user.get('id')) && (user.get('id') == check)
    } else if (type == 'responsable_soma') {
        if (user.get('es_superusuario') === 1) return true
        //return ((solicitud.get('responsables_ingreso').filter(x => x.get('usuario_id') == user.get('id')).count() > 0) || solicitud.getIn(['responsable_compras', 'id']) === user.get('id'))
    } else if (type == 'responsable_compras') {
        if (user.get('es_superusuario') === 1) return true
        return obj.get('responsable_compras_id') === user.get('id')
    } else if (type == 'solicitante') {
        if (user.get('es_superusuario') === 1) return true
        return obj.get('solicitante_id') === user.get('id') || obj.get('responsable_compras_id') === user.get('id')
    } else if (type == 'aprobador_primer_nivel') {
        if ((user.get('es_superusuario') != 1)) {
            return obj.filter(aprobador => aprobador.get('id') == user.get('id') && aprobador.get('aprobaciones').filter(a => a.get('tipo') == 1).count() > 0).count() > 0
        } else {
            return true
        }
    }

    return true
}



export function romanize (num) {
	if (!+num)
		return false;
	var	digits = String(+num).split(""),
		key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM",
		       "","X","XX","XXX","XL","L","LX","LXX","LXXX","XC",
		       "","I","II","III","IV","V","VI","VII","VIII","IX"],
		roman = "",
		i = 3;
	while (i--)
		roman = (key[+digits.pop() + (i * 10)] || "") + roman;
	return Array(+digits.join("") + 1).join("M") + roman;
}



export function attachFilesToEntity(entity, list) {
    return list
    .filter(c => c.getIn(['adjunto', 'entities']))
    .map(a => a.get('adjunto').update('entities', x => x.push(Immutable.fromJS({entity, guid: a.get('guid') }))))
}


export function getPorcentaje(total, porcentaje) {
    if (porcentaje)
        return ((porcentaje * total) / 100)
    else
        return 0
}

export function getPorcentajeFromTotal(total, iva_value) {
    if (iva_value) {
        let formula = `(${iva_value} * 100)/${total}`
        return exactMath.formula(formula)
    }
    else
        return 0
}

export function getTotalesDocumento(documento) {

    const totales = {
        sin_iva: 0,
        con_iva: 0
    }

    documento.get('detalles').forEach(a => {
        totales.sin_iva += a.get('valor') * a.get('cantidad')
        totales.con_iva += a.get('valor_con_iva') * a.get('cantidad')
    })


    documento.get('documentos').forEach(b => {
        b.get('detalles').forEach(c => {
            totales.sin_iva += c.get('valor') * c.get('cantidad')
            totales.con_iva += c.get('valor_con_iva') * c.get('cantidad')
        })
    })


    const facturas = {
        sin_iva: 0,
        con_iva: 0
    }

    documento.get('facturas').forEach(f => {
        facturas.sin_iva += f.get('valor_sin_iva')
        facturas.con_iva += f.get('valor_con_iva')
    })

    totales.sin_iva -= facturas.sin_iva
    totales.con_iva -= facturas.con_iva

    totales.sin_iva = Number(totales.sin_iva.toFixed(2))
    totales.con_iva = Number(totales.con_iva.toFixed(2))

    return totales

}


export function calcularAnticipos(doc, origen) {

    let total = 0

    if (doc.get('documentos')) {
        doc.get('documentos').map(d => total += calcularAnticipos(d, doc))
    }
    if (doc.get('tipo') == 6) {
        const totalSevicios = origen.get('detalles').reduce((a, b) => {
            if (!b.get('adicion_id')) a += b.get('valor')
            return a
        }, 0)
        total += (totalSevicios * (origen.get('anticipo'))) / 100
    }

    total = Number(total.toFixed(2))

    return total
}


export function formatcoin(value,coin=false) {
    return coin ? `${coin} ${ numeral(value).format('0,0.00') }` : `${ numeral(value).format('0,0.00') }`
}


export function getDivisa(divisas, moneda) {
    const d = { moneda: 'COP', simbolo: '$' }
    if (divisas) {
        const divisa = divisas.filter(d => d.get('CODIGO') == moneda)
        if (divisa.count() > 0) {
            d.moneda = moneda
            d.simbolo = divisa.first().get('SIMBOLO')
        }
    }
    return d
}








// WEBPACK FOOTER //
// ./src/utils/helpers.js